import { useAppSelector } from '../../../hooks/redux'
import { Strings } from '../../../constants/Strings'
import { Colors } from '../../../constants/Colors'
import style from '../../../rootStyles/Content.module.css'
import Header from '../../../components/Header/Header'
import { Methods } from '../../../constants/Methods'

const Content = () => {

    const theme = useAppSelector<string>(state => state.theme.theme)
    const language = useAppSelector<string>(state => state.language.language)
    
    return (
        <div
            className={style.container}
            style={{
                backgroundColor: Colors[theme ?? 'light'].background
            }}
        >
            <Header
                leftIcon={null}
                leftPath={null}
                leftClick={null}
                title={Strings[language ?? 'tm'].privacyPolicy}
                rightIcon={null}
                rightPath={null}
                rightClick={null}
            />
            <div
                className={style.content}
            >
                <div className={style.textsContainer}>

                    <span
                        className={style.title}
                        style={{
                            color: Colors[theme ?? 'light'].app
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyTitle}
                    </span>

                    {/* PROFILES */}
                    <span
                        className={style.subtitle}
                        style={{
                            color: Colors[theme ?? 'light'].textLight
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDatasUsersScroll}
                    </span>
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsers}
                    </span>
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDatasUsers}
                    </span>

                    {/* 1. PROFILES PHONE */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersPhone}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersPhone1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersPhone2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersPhone3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersPhone4}
                    </span>
                    
                    {/* 2. PROFILES NAME */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersName}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersName1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersName2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersName3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersName4}
                    </span>

                    {/* 3. PROFILES ADDRESS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersAddress}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersAddress1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersAddress2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersAddress3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersAddress4}
                    </span>
                    
                    {/* 4. PROFILES RATES */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersRate}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersRate1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersRate2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersRate3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersRate4}
                    </span>

                    {/* 5. PROFILES CARTS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersCart}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersCart1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersCart2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersCart3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersCart4}
                    </span>

                    {/* 6. PROFILES SHOPPING */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersShopping}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersShopping1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersShopping2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersShopping3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersShopping4}
                    </span>

                    {/* PROFILES ENCRYPT */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataUsersEncryptTitle}
                    </span>
                    


                    {/* STORES */}
                    <span
                        className={style.subtitle}
                        style={{
                            color: Colors[theme ?? 'light'].textLight
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDatasStoresScroll}
                    </span>
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStores}
                    </span>
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDatasStores}
                    </span>

                    {/* 1. STORES TITLE */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresTitle}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresTitle1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresTitle2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresTitle3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresTitle4}
                    </span>

                    {/* 2. STORES MEDIA */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresMedia}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresMedia1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresMedia2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresMedia3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresMedia4}
                    </span>

                    {/* 3. STORES PHONE */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresPhone}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresPhone1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresPhone2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresPhone3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresPhone4}
                    </span>

                    {/* 4. STORES EMAIL */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresEmail}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresEmail1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresEmail2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresEmail3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresEmail4}
                    </span>

                    {/* 5. STORES WORK DAYS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresWorkDays}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresWorkDays1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresWorkDays2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresWorkDays3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresWorkDays4}
                    </span>

                    {/* 6. STORES DELIVERY */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresDelivery}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresDelivery1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresDelivery2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresDelivery3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresDelivery4}
                    </span>

                    {/* 7. STORES PAYMENTS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresPayment}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresPayment1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresPayment2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresPayment3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresPayment4}
                    </span>

                    {/* 8. STORES ADDRESS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresAddress}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresAddress1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresAddress2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresAddress3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresAddress4}
                    </span>

                    {/* 9. STORES PRODUCTS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresProduct}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresProduct1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresProduct2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresProduct3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresProduct4}
                    </span>

                    {/* 10. STORES CART */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresCart}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresCart1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresCart2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresCart3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresCart4}
                    </span>

                    {/* 11. STORES SHOPPING */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresShopping}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresShopping1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresShopping2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresShopping3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresShopping4}
                    </span>

                    {/* STORES ENCRYPT */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataStoresEncryptTitle}
                    </span>



                    {/* COURIERS */}
                    <span
                        className={style.subtitle}
                        style={{
                            color: Colors[theme ?? 'light'].textLight
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDatasCouriersScroll}
                    </span>
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriers}
                    </span>
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDatasCouriers}
                    </span>

                    {/* 1. COURIERS NAME */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersName}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersName1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersName2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersName3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersName4}
                    </span>

                    {/* 2. COURIERS PHONE */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersPhone}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersPhone1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersPhone2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersPhone3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersPhone4}
                    </span>

                    {/* 3. COURIERS ADDRESS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersAddress}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersAddress1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersAddress2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersAddress3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersAddress4}
                    </span>

                    {/* 4. COURIERS PHOTOS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersPhoto}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersPhoto1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersPhoto2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersPhoto3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersPhoto4}
                    </span>

                    {/* 5. COURIERS CARTS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersCart}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersCart1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersCart2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersCart3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersCart4}
                    </span>

                    {/* 6. COURIERS SHOPPING */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersShopping}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersShopping1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersShopping2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersShopping3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersShopping4}
                    </span>

                    {/* COURIERS ENCRYPT */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].privacyPolicyDataCouriersEncryptTitle}
                    </span>



                    {/* SUPPORTS AND CONTACTS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appSupport}
                    </span>
                    <a
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                        href="mailto:lezzetsebeti@gmail.com"
                    >
                        {Strings[language ?? 'tm'].email}: lezzetsebeti@gmail.com
                    </a>
                    <a
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                        href="tel:+99371814745"
                    >
                        {Strings[language ?? 'tm'].phone}: {Methods.getNextPhone('+993 71814745')}
                    </a>

                    {/* COPYRIGHT */}
                    <span
                        className={style.title}
                        style={{
                            color: Colors[theme ?? 'light'].app
                        }}
                    >
                        {Strings[language ?? 'tm'].copyright}
                    </span>
                        
                </div>
            </div>
        </div>
    )
}

export default Content